import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import dayjs from "dayjs";

// Import styles
import "./ProgramDetail.css";

// Import components
import Sidebar from "../sidebar/Sidebar";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CalenderView from "./CalenderView";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalViewAttachmets from "../Attachments/ModalViewAttachmets";
import ErrorModal from "../common/ErrorModal/ErrorModal";
import ProgramDetailsHeader from "./components/ProgramDetailsHeader";
import WorkoutNavigation from "./components/WorkoutNavigation";
import WorkoutList from "./components/WorkoutList";
import CopyWorkoutModal from "./components/CopyWorkoutModal";
import UserManagementModal from "./components/UserManagementModal";
import MergeExerciseModal from "./components/MergeExerciseModal";
import DragReorderView from "./components/DragReorderView";
import VideoPlayerOverlay from "../workout/common/VideoPlayerOverlay";

// Import hooks and business logic
import { useProgramDetail } from "./hooks/useProgramDetail";
import { useProgramActions } from "./hooks/useProgramActions";

// Import services and utilities
import { Services } from "../../api/Services";
import { getImageUrl, BASE_URL_MEDIA, BASE_URL_COMPETITION } from "../../api/Constants";

// Import images
import gymimage from "../../images/gym.jpg";
import placeimg from "../../images/placeholder.png";
import gymgirl from "../../images/gymgirl.jpg";

function ProgramDetail() {
  const { id } = useParams();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const navigate = useNavigate();
  
  // Video overlay state
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoTitle, setVideoTitle] = useState("Video");

  const openProgramVideo = () => {
    const url = programState.detail?.video || programState.detail?.youtube_link || "";
    if (!url) return;
    setVideoUrl(url);
    setVideoTitle(programState.detail?.name || "Video");
    setIsVideoOpen(true);
  };

  // Use custom hooks for state and actions
  const programState = useProgramDetail(id);
  const programActions = useProgramActions(programState);

  const {
    // State variables
    detail, workouts, viewType, setViewType, weeks, currentweek, currentDay,
    isLoading, isLoad, setisLoad, order, setorder, isShow, setisShow,
    showModal, setShowModal, selectedWokrout, setSelectedWorkout,
    showProgramAttachmentModal, setShowProgramAttachmentModal,
    confirmActionModal, setConfirmActionModal, actionModalMessage, 
    setActionModalMessage, actionButtonTitle, selectedActionObj,
    selectedActionObj2, selectedActionObjType,
    
    // Copy modal state
    isCopy, setIsCopy, programs, pvalue, setPvalue, copyDetail,
    selectedworks, workIds, 
    
    // User management state  
    isusers, setIsusers, show, setShow, assign, setAssign,
    users, setUsers, selectedusers, usersIds, userinput,
    groupList, groupId, assigneDate, setAssignDate,
    
    // Merge exercise state
    merge, setMerge, removeMerge, setRemoveMerge,
    selectedExerciseIds, selectedExerciseremoveIds,
    selectWorkout, mvideo, setMvideo, mergeId,
    
    // Utility functions
    formattedDate, setWeek, setDay, formateSetsinputs
  } = programState;

  const {
    // Action functions
    deleteProgram, duplicateProgram, deleteWorkout, duplicateWorkout,
    handleExerciseClick, handleExerciseClickRemove, openMergeModal, openRemoveModal,
    onDragEnd, reOrderWorkout, copyWorkoutNow, handleProgramChange,
    handleUserInputChange, handleAssign, handleGroupChange,
    toggleUser, toggleWorkout, assignUsers, showUserStats,
    mergeExercisesNow, removeMergeNow
  } = programActions;

  // Create payload objects for merge operations
  const mergePayLoad = {
    id: 0,
    workout_id: selectWorkout || "",
    program_id: id,
    video: mvideo || "",
    add_exercises: selectedExerciseIds || [],
    remove_exercises: selectedExerciseremoveIds || [],
  };

  const removePayLoad = {
    id: mergeId,
    workout_id: selectWorkout || "",
    program_id: id,
    video: mvideo || "",
    add_exercises: selectedExerciseIds || null,
    remove_exercises: selectedExerciseremoveIds || [],
  };

  const payLoad = {
    program_id: id,
    workouts: workouts?.map((work, index) => ({
      id: work.id,
      order: index,
    })),
  };

  // Helper functions
  const removeUser = (item) => {
    programActions.showConfirmModal(
      "Do you want to remove user?",
      "Yes", 
      "remove_user",
      item,
      null
    );
  };

  const removeWork = (item) => {
    programActions.showConfirmModal(
      "Do you want to remove workout?",
      "Yes",
      "remove_workout", 
      item,
      null
    );
  };

  const handleViewAttachment = (workout) => {
    setSelectedWorkout(workout);
    setShowModal(true);
  };

  const handleProgramViewAttachment = () => {
    setShowProgramAttachmentModal(true);
  };

  const viewWorkoutAttachment = () => {
    return (
      <ModalViewAttachmets
        wokroutId={selectedWokrout?.id}
        programId={id}
        setShowModal={setShowModal}
      />
    );
  };

  const viewProgramAttachment = () => {
    return (
      <ModalViewAttachmets
        wokroutId={0}
        programId={id}
        setShowModal={setShowProgramAttachmentModal}
      />
    );
  };

  const showActionModal = () => {
    return (
      <ErrorModal 
        handleOK={handleActionConfirmed}
        errorMessage={actionModalMessage}
        setErrorMessage={setActionModalMessage}
        setErrorModal={setConfirmActionModal}
        actionButtonTitle={actionButtonTitle}
      />
    );
  };

  const handleActionConfirmed = async () => {
    if (selectedActionObjType === "delete_workout") {
      try {
        setisLoad(true);
        const result = await Services.deleteWorkout(selectedActionObj.id, selectedActionObj2);
        if (result.status === 200) {
          toast.success("Workout deleted successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setorder(0);
          programState.programmDetail(
            localStorage.getItem("program_id"),
            currentDay,
            currentweek
          );
        } else {
          toast.error(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
        setisLoad(false);
      }
    } else if (selectedActionObjType === "complete_program") {
      try {
        setisLoad(true);
        const result = await Services.completeProgramuser(selectedActionObj, selectedActionObj2);
        if (result.status === 200) {
          toast.success("Program completed for user!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          programState.programmDetail(id, currentDay, currentweek);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
        setisLoad(false);
      }
    } else if (selectedActionObjType === "reopen_program") {
      try {
        let program_id = selectedActionObj;
        let groupid = selectedActionObj2;
        setisLoad(true);
        const result = await Services.reopenProgramgroup(program_id, groupid);
        if (result.status === 200) {
          toast.success("Program reopened for group!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          programState.programmDetail(id, currentDay, currentweek);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
        setisLoad(false);
      }
    } else if (selectedActionObjType === "reopen_program_user") {
      let program_id = selectedActionObj;
      let userid = selectedActionObj2;
      setisLoad(true);
      try {
        const result = await Services.reopenProgramuser(program_id, userid);
        if (result.status === 200) {
          toast.success("Program reopened for user!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          programState.programmDetail(id, currentDay, currentweek);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
        setisLoad(false);
      }
    } else if (selectedActionObjType === "delete_group") {
      let program_id = selectedActionObj;
      let group = selectedActionObj2;
      setisLoad(true);
      try {
        const result = await Services.removeGroupFromProgram(program_id, group);
        if (result.status === 200) {
          toast.success("Group deleted from program successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          programState.programmDetail(id, currentDay, currentweek);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
        setisLoad(false);
      }
    } else if (selectedActionObjType === "delete_user") {
      let program_id = selectedActionObj;
      let userid = selectedActionObj2;
      setisLoad(true);
      try {
        const result = await Services.removeUserFromProgram(program_id, userid);
        if (result.status === 200) {
          toast.success("User deleted from program successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          programState.programmDetail(id, currentDay, currentweek);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
        setisLoad(false);
      }
    } else if (selectedActionObjType === "duplicate_program") {
      try {
        let programId = selectedActionObj;
        const result = await Services.duplicateProgram(programId);
        if (result.status === 200) {
          toast.success("Program duplicated successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            navigate("/programm-list");
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        console.log(error);
      }
    } else if (selectedActionObjType === "remove_workout") {
      let item = selectedActionObj;
      if (selectedworks.includes(item)) {
        programState.setSelectedworks(
          selectedworks.filter((selectedItem) => selectedItem !== item)
        );
        programState.setWorkIds(workIds.filter((selectedId) => selectedId !== item?.id));
      }
    } else if (selectedActionObjType === "remove_user") {
      let item = selectedActionObj;
      if (selectedusers.includes(item)) {
        programState.setSelectedusers(
          selectedusers.filter((selectedItem) => selectedItem !== item)
        );
        programState.setUsersIds(usersIds.filter((selectedId) => selectedId !== item?.id));
      }
    } else if (selectedActionObjType === "duplicate_workout") {
      try {
        let pid = selectedActionObj;
        let wid = selectedActionObj2;
        const result = await Services.duplicateWorkout(pid, wid);
        if (result.status === 200) {
          toast.success("Workout duplicated successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            programState.programmDetail(id, currentDay, currentweek);
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        console.log(error);
      }
    } else if (selectedActionObjType === "delete_program") {
      let programId = selectedActionObj;
      setisLoad(true);
      try {
        const result = await Services.deleteProgramm(programId);
        if (result.status === 200) {
          toast.success("Program deleted successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            navigate("/programm-list");
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
        setisLoad(false);
      }
    }
    setConfirmActionModal(false);
  };

  const renderTitleTopBar = () => {
    return (
      <ProgramDetailsHeader
        detail={detail}
        viewType={viewType}
        setViewType={setViewType}
        onDeleteProgram={() => deleteProgram()}
        onDuplicateProgram={() => duplicateProgram()}
        onShowUsers={() => programState.setIsusers(true)}
        onViewProgramAttachment={handleProgramViewAttachment}
        navigate={navigate}
        id={id}
        isFilterVisible={isFilterVisible}
        onToggleFilter={() => setIsFilterVisible((v) => !v)}
        onPlayVideo={openProgramVideo}
      />
    );
  };

  // Additional helper functions for user/group management
  const deleteuserFromProg = (program_id, userid) => {
    programActions.showConfirmModal(
      "Are you sure you want to remove member?",
      "Delete",
      "delete_user",
      program_id,
      userid
    );
  };

  const deleteGroupFromProg = (program_id, group) => {
    programActions.showConfirmModal(
      "Are you sure you want to remove Group from program?",
      "Delete",
      "delete_group",
      program_id,
      group
    );
  };

  const reOpenForUser = (program_id, userid) => {
    programActions.showConfirmModal(
      "Are you sure you want to reopen this program for this user?",
      "Reopen",
      "reopen_program_user",
      program_id,
      userid
    );
  };

  const reOpenForGroup = (program_id, groupid) => {
    programActions.showConfirmModal(
      "Are you sure you want to reopen program for this group?",
      "Yes",
      "reopen_program",
      program_id,
      groupid
    );
  };

  const completeForUser = (program_id, userid) => {
    programActions.showConfirmModal(
      "Are you sure you want to complete program for this user?",
      "Yes",
      "complete_program",
      program_id,
      userid
    );
  };

  return (
    <div className="wrapper-dashboard">
      {showModal && viewWorkoutAttachment()}
      {showProgramAttachmentModal && viewProgramAttachment()}
      {confirmActionModal && showActionModal()}

      {/* Copy Workout Modal */}
      {isCopy && (
        <CopyWorkoutModal
          isVisible={isCopy}
          programs={programs}
          pvalue={pvalue}
          onProgramChange={handleProgramChange}
          copyDetail={copyDetail}
          selectedworks={selectedworks}
          workIds={workIds}
          onCopyWorkout={copyWorkoutNow}
          onToggleWorkout={toggleWorkout}
          onRemoveWork={removeWork}
          onClose={() => setIsCopy(false)}
          detail={detail}
        />
      )}

      {/* Loading Spinner */}
      {isLoad && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}

      {/* User Management Modal */}
      {isusers && (
        <UserManagementModal
          isVisible={isusers}
          detail={detail}
          show={show}
          onToggleShow={() => setShow((prev) => !prev)}
          assign={assign}
          onAssignChange={handleAssign}
          formattedDate={formattedDate}
          assigneDate={assigneDate}
          onAssignDateChange={(e) => setAssignDate(e.target.value)}
          usersIds={usersIds}
          groupId={groupId}
          onAssignNow={assignUsers}
          userinput={userinput}
          onUserInputChange={handleUserInputChange}
          users={users}
          onSetUsers={setUsers}
          selectedusers={selectedusers}
          onToggleUser={toggleUser}
          onRemoveUser={removeUser}
          groupList={groupList}
          onGroupChange={handleGroupChange}
          onDeleteUserFromProg={deleteuserFromProg}
          onDeleteGroupFromProg={deleteGroupFromProg}
          onCompleteForUser={completeForUser}
          onReOpenForUser={reOpenForUser}
          onReOpenForGroup={reOpenForGroup}
          onShowUserStats={showUserStats}
          onClose={() => setIsusers(false)}
          id={id}
        />
      )}

      <ToastContainer />
      
      <div className="left">
        <Sidebar />
      </div>
      
      <div className="right">
        {/* Back Button - styled to match the app's UI */}
        <button
          className="btn btn-light back-btn"
          onClick={() => navigate(-1)}
          style={{ margin: '20px 0 12px 0', padding: '6px 18px', fontSize: '15px', borderRadius: '6px', border: '1px solid #ddd', background: '#fff', color: '#333', boxShadow: '0 1px 4px rgba(0,0,0,0.04)', display: 'inline-flex', alignItems: 'center', gap: '8px', cursor: 'pointer', transition: 'background 0.2s' }}
          onMouseOver={e => e.currentTarget.style.background = '#f5f5f5'}
          onMouseOut={e => e.currentTarget.style.background = '#fff'}
        >
          <i className="fa-solid fa-arrow-left" style={{ fontSize: '16px' }}></i>
          <span style={{ fontWeight: 500 }}>Back</span>
        </button>
        {/* Program Details Header - Always visible */}
        {renderTitleTopBar()}

        {/* Calendar View */}
        {viewType === "calander" && (
          <CalenderView
            id={id}
            detailId={detail?.id}
            currentDay={currentDay}
          />
        )}

        {/* List View */}
        {viewType === "list" && (
          <div className="program-content">
              {/* Loader above calendar/list view for programmDetail API */}
              {isLoading && (
                <div className="loaderparent" style={{marginBottom: 24}}>
                  <div className="loader"></div>
                </div>
              )}
            {/* Workout Navigation */}
            {isFilterVisible && (
              <WorkoutNavigation
                weeks={weeks}
                currentweek={currentweek}
                currentDay={currentDay}
                onWeekChange={setWeek}
                onDayChange={setDay}
                cweek={localStorage.getItem("cweek")}
              />
            )}

            {/* Workout Management Controls */}
            <div className="workout-controls">
              <div className="workout-actions">
                <div className="action-button-with-desc">
                  <button
                    className="btn btn-primary"
                    onClick={() => setIsCopy(true)}
                  >
                    <i className="fa-solid fa-copy"></i>
                    Copy workouts
                  </button>
                  <small className="button-description">
                    Import workouts from other programs
                  </small>
                </div>
                {workouts?.length > 1 && (
                  <button
                    className="btn btn-secondary"
                    onClick={() => programState.setReorder((reor) => !reor)}
                  >
                    <i className="fa-solid fa-arrows-up-down"></i>
                    Re-order workouts
                  </button>
                )}
              </div>
              <div className="workout-count">
                <span>
                  {detail?.workouts?.length || 0}{" "}
                  {detail?.workouts?.length === 1 ? "Workout" : "Workouts"}
                </span>
              </div>
            </div>

            {/* Workout List Container */}
            <div className="workouts-container">
              {/* Normal Workout List */}
              <div className={programState.reorder === false ? "orderhide" : ""}>
                <WorkoutList
                  workouts={detail?.workouts}
                  isLoading={isLoading}
                  order={order}
                  isShow={isShow}
                  onOrderChange={setorder}
                  onShowToggle={() => setisShow((itm) => !itm)}
                  onMergeModal={openMergeModal}
                  onDeleteWorkout={deleteWorkout}
                  onDuplicateWorkout={duplicateWorkout}
                  onViewAttachment={handleViewAttachment}
                  formateSetsinputs={formateSetsinputs}
                  detail={detail}
                  programId={id}
                  currentDay={currentDay}
                  merge={merge}
                  removeMerge={removeMerge}
                />

                {/* Merge Exercise Modal */}
                {merge && (
                  <MergeExerciseModal
                    isVisible={merge}
                    title="Select exercises to merge"
                    workout={workouts.find(w => w.id === selectWorkout)}
                    selectedExerciseIds={selectedExerciseIds}
                    mvideo={mvideo}
                    onVideoChange={(e) => setMvideo(e.target.value)}
                    onExerciseClick={handleExerciseClick}
                    onMergeExercises={() => mergeExercisesNow(mergePayLoad)}
                    onClose={() => setMerge(false)}
                    formateSetsinputs={formateSetsinputs}
                    isRemoveMode={false}
                  />
                )}

                {/* Remove Merge Modal */}
                {removeMerge && (
                  <MergeExerciseModal
                    isVisible={removeMerge}
                    title="Select exercises to remove"
                    workout={workouts.find(w => w.id === selectWorkout)}
                    selectedExerciseremoveIds={selectedExerciseremoveIds}
                    mvideo={mvideo}
                    onVideoChange={(e) => setMvideo(e.target.value)}
                    onExerciseClickRemove={handleExerciseClickRemove}
                    onRemoveMergedExercises={() => removeMergeNow(removePayLoad)}
                    onClose={() => setRemoveMerge(false)}
                    formateSetsinputs={formateSetsinputs}
                    mergeId={mergeId}
                    isRemoveMode={true}
                  />
                )}
              </div>

              {/* Drag and Drop Reorder View */}
              <div className="workoutul">
                <div className={programState.reorder === true ? "orderhide" : ""}>
                  <DragReorderView
                    isVisible={!programState.reorder}
                    workouts={workouts}
                    onDragEnd={onDragEnd}
                    onSaveChanges={() => reOrderWorkout(payLoad)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Video overlay */}
      <VideoPlayerOverlay
        isOpen={isVideoOpen}
        onClose={() => setIsVideoOpen(false)}
        url={videoUrl}
        title={videoTitle}
      />
    </div>
  );
}

export default ProgramDetail;
